import React from "react";

const VersionInfo = () => {
  return (
    <div
      id="version-info"
      style={{
        display: "none",
        position: "fixed",
        bottom: "0",
        left: "0",
        background: "rgba(0, 0, 0, 0.5)",
        color: "white",
        padding: "5px",
      }}
    >
      Version: {process.env.REACT_APP_VERSION} <br />
      Build: {process.env.REACT_APP_BUILD_NUMBER}
    </div>
  );
};

export default VersionInfo;
